"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialogContext = exports.DialogContextProvider = exports.dialogContext = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
const initialContext = {
    onClose: noop_1.default,
    isSmallestDialog: false,
    showXsDialogBorders: false,
    showCloseButton: true,
};
exports.dialogContext = (0, react_1.createContext)(initialContext);
exports.DialogContextProvider = exports.dialogContext.Provider;
const useDialogContext = () => {
    const context = (0, react_1.useContext)(exports.dialogContext);
    if (!context) {
        throw new Error('Dialog compound components cannot be rendered outside the Dialog component');
    }
    return context;
};
exports.useDialogContext = useDialogContext;
